<template>
  <div class="home-page">
    <!-- 1. 顶部满屏 Banner（视频背景） -->
    <section class="banner relative w-full md:h-[880px] h-[210px] overflow-hidden mt-[-80px]">
      <!-- 视频背景 -->
      <video class="absolute w-full h-full object-cover" autoplay loop muted playsinline>
        <source src="@/assets/video/home2.mp4" type="video/mp4" />
      </video>

      <!-- 遮罩层（可选） -->
      <div class="absolute inset-0 bg-black/30"></div>

      <!-- 内容 -->
      <div class="relative z-10 md:mt-[257px] mt-[70px] h-full px-4 md:max-w-[56%] max-w-[94%] mx-auto">
        <div class="text-white md:text-[64px] text-[28px] font-bold leading-tight">
          重塑菌物 生长法则
        </div>
        <div class="md:text-[16px] text-[10px] text-white md:w-[432px] font-light mt-[20px]">
          让每一朵蘑菇都在算法中诞生。突破自然环境限制，在任何角落打造稳定、高产、极致纯净的地下微型森林。
        </div>
        <div class="md:block hidden">

          <div class="mt-[230px] flex space-x-10 text-white text-lg">
            <div>
              <div class="text-[15px] font-light">产量提升</div>
              <div class="text-[36px] font-bold mt-[10px]">70%</div>
            </div>
            <div>
              <div class="text-[15px] font-light">节约水量</div>
              <div class="text-[36px] font-bold mt-[10px]">60%</div>
            </div>
            <div>
              <div class="text-[15px] font-light">占地面积</div>
              <div class="text-[36px] font-bold mt-[10px]">32,450 ㎡</div>
            </div>
            <div>
              <div class="text-[15px] font-light">实时调控</div>
              <div class="text-[36px] font-bold mt-[10px]">24H</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 2. 公司介绍 -->
    <section class="md:max-w-[56%] max-w-[94%] mx-auto">
      <div
        class="flex flex-col bg-white relative md:top-[-50px] z-10 md:flex-row items-center gap-8 md:shadow-[3px_3px_10px_rgba(0,0,0,0.4)]">

        <div class="md:block hidden w-[600px] mt-[-125px] z-10 md:w-1/2">
          <img src="@/assets/home/微信图片_20260401102719.png" alt="公司大楼" class="w-full h-auto rounded" />
        </div>

        <div class="w-full md:w-1/2 md:pr-8 pb-8">
          <div class="md:hidden md:text-[24px] text-[16px] font-bold text-[#333] mb-7 text-center mt-[40px]">
            <img class="w-[18px] h-[18px]" src="@/assets/home/mb_icon.png" alt="">
            <div class="mt-2">关于菌丰</div>
          </div>
          <h2 class="text-[#41B56F] md:text-[28px] text-[16px] font-bold mt-[40px] md:text-left text-center">
            北京菌丰生物科技有限公司</h2>
          <p class="text-[#BCBCBC] text-[10px] mb:text-[18px] mb-2 md:text-left text-center">Beijing Junfeng
            Biotechnology Co., Ltd.</p>
          <div class="md:block hidden w-[80px] h-[5px] bg-[#41B56F] mb-5"></div>
          <p class="text-[#000000] text-[14px] leading-[1.8] text-indent md:text-left text-center">
            北京菌丰生物科技有限公司 2016 年成立，总部坐落于北京昌平科技园区，是专注食用菌全产业链发展的高科技生物企业。
          </p>
          <p class="text-[#000000] text-[14px] leading-[1.8] mb-5 text-indent md:text-left text-center">
            公司作为国内领先的智能化食用菌种植解决方案提供商，深耕农业数字化与生物制造融合创新，自主研发 JF-A 系列智能化仿生仓，依托温湿光气精准调控、自动化生产及云端数据管理，实现菌菇全年稳定高效生产
          </p>
          <div @click="$router.push('/about/company')"
            class="cursor-pointer flex items-center gap-2 text-[#41B56F] text-[16px] font-medium jus md:justify-start justify-center">
            <span>查看更多</span>
            <i class="el-icon-right"></i>
          </div>
        </div>
      </div>
    </section>
    <!-- 3. 产品展示：JF-A系列智能化培养仓 -->
    <section class="md:py-16 bg-gray-50">
      <div
        class="md:flex md:max-w-[56%] max-w-[94%] mx-auto md:px-14 md:py-12 md:hover:shadow-[0_8px_20px_rgba(0,0,0,0.15)]">
        <div class=" md:w-1/2">
          <img src="@/assets/home/Rectangle_11.png" alt="JF-A培养仓" class="w-[100%] mx-auto" />
        </div>
        <div class="md:w-1/2 md:pl-[30px]">
          <div class="md:text-[32px] text-[14px] font-bold text-black md:mb-7 mb-4 md:text-left text-center"> JF-A
            系列智能化立体仿生仓</div>
          <p
            class="text-gray-600 md:text-[14px] text-[14px] md:mb-8 mb-4 max-w-2xl leading-[1.8] mx-auto md:text-left text-center text-indent">
            通过模拟自然生态环境，打破传统农业对气候与地域的依赖，实现菌菇生产的工业化、可控化与高效化 —— 现代农业智慧转型的核心载体。
          </p>
          <div
            class="mt-8 cursor-pointer text-white md:w-[150px] md:h-[30px] w-[80px] h-[20px] mx-auto md:ml-0 text-center bg-[#41B56F] leading-[1.8] md:text-[16px] text-[12px]"
            @click="goDetail(1)">
            了解更多</div>
        </div>
      </div>
    </section>

    <!-- 4. 基地介绍 -->
    <section class=" md:max-w-[56%] max-w-[94%] mx-auto md:px-4 relative">
      <!-- 标题 -->
      <div class="text-center md:mb-16 mb-12">
        <img class="md:hidden w-[18px] h-[18px] mt-14" src="@/assets/home/mb_icon.png" alt="">
        <h2 class="md:text-[#41B56F] text-[#333] md:text-[44px] md:text-[24px] text-[12px] font-bold mb-3">基地介绍</h2>
        <p class="text-gray-500 text-[16px] hidden md:block ">依托先进的生物技术和智能化设施，打造标准化、规模化的食用菌种植示范中心。</p>
      </div>

      <!-- 轮播主体 -->
      <div class="flex justify-between w-full items-center gap-6">
        <!-- 左箭头 -->
        <!-- <i @click="prev" :class="currentIndex === 0 ? 'text-gray-300' : 'text-[#41B56F]'" :disabled="currentIndex === 0"
          class="el-icon-arrow-left text-3xl transition-colors"></i> -->
        <i @click="currentIndex > 0 && prev()"
          :class="currentIndex === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-[#41B56F] cursor-pointer'"
          class="el-icon-arrow-left text-3xl transition-colors"></i>
        <!-- 轮播图片 -->
        <!-- <div class="w-[35%]">
          <img :src="images[currentIndex]" class="w-full h-auto rounded-lg shadow-[3px_3px_10px_rgba(0,0,0,0.1)]" />
        </div> 
        <div class="w-[35%]">
          <img :src="images[currentIndex + 1]" class="w-full h-auto rounded-lg shadow-[3px_3px_10px_rgba(0,0,0,0.1)]" />
        </div>
        -->
        <div class="w-[35%] relative overflow-hidden rounded-lg group cursor-pointer"  @click="$router.push(images[currentIndex].link)">
          <!-- 图片 -->
          <img :src="images[currentIndex].url"
            class="w-full h-auto rounded-lg shadow-[3px_3px_10px_rgba(0,0,0,0.1)] transition-all duration-500 group-hover:scale-110" />
          <!-- 悬浮遮罩 + 文字 -->
          <div class="absolute inset-0 bg-black/30 opacity-0 transition-opacity duration-300 
              group-hover:opacity-100 flex items-center justify-center">
            <div class="text-white text-center">
              <i class="el-icon-map-location md:text-3xl text-xl"></i>
              <p class="md:text-lg text-xs">{{ images[currentIndex].title }}</p>
            </div>
          </div>
        </div>
        <div class="w-[35%] relative overflow-hidden rounded-lg group cursor-pointer"
          @click="$router.push(images[currentIndex + 1].link)">
          <!-- 图片 -->
          <img :src="images[currentIndex + 1].url"
            class="w-full h-auto rounded-lg shadow-[3px_3px_10px_rgba(0,0,0,0.1)] transition-all duration-500 group-hover:scale-110" />
          <!-- 悬浮遮罩 + 文字 -->
          <div class="absolute inset-0 bg-black/30 opacity-0 transition-opacity duration-300 
              group-hover:opacity-100 flex items-center justify-center">
            <div class="text-white text-center">
              <i class="el-icon-map-location text-3xl"></i>
              <p class="text-lg">{{ images[currentIndex + 1].title }}</p>
            </div>
          </div>
        </div>
        <!-- 右箭头 -->
        <i @click="currentIndex < images.length - 2 && next()"
          :class="currentIndex >= images.length - 2 ? 'text-gray-300 cursor-not-allowed' : 'text-[#41B56F] cursor-pointer'"
          class="el-icon-arrow-right text-3xl transition-colors"></i>

      </div>
    </section>

    <!-- 5. 重新定义生产力 -->
    <section class="py-16 bg-white">
      <div class="md:max-w-[56%] max-w-[94%] mx-auto px-4 text-center">
        <h2 class="text-[#41B56F] text-[44px] font-bold mb-4 md:block hidden">重新定义生产力</h2>
        <p class="text-gray-500 text-[18px] mb-[100px] max-w-2xl mx-auto md:block hidden">
          打破传统农业靠天吃饭的桎梏，让确定性成为新常态。
        </p>

        <!-- 外层：只加 overflow-hidden + 鼠标事件 -->
        <!-- 外层：overflow-hidden 滚动容器，ref 放这里，鼠标悬停暂停 -->
        <div class="overflow-hidden" ref="scroll" @mouseenter="stopLoop" @mouseleave="loop">
          <!-- 内层：w-max 让内容撑开超出容器，才能滚动 -->
          <div class="flex md:gap-8 gap-0  w-max">
            <!-- ========== 第一份：4 个模块（原样） ========== -->
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame.png" alt="模式闭环" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">模式闭环</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">全产业链贯通，品质成本双可控</p>
            </div>
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame_1.png" alt="技术领先" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">技术领先</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">JF-A 仿生仓 + 8 项专利，效率提升 30%+</p>
            </div>
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame_2.png" alt="渠道确定" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">渠道确定</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">包销协议锁定，以销定产现金流稳</p>
            </div>
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame_3.png" alt="品种稀缺" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">品种稀缺</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">金耳/舞茸/双孢菇高溢价矩阵</p>
            </div>

            <!-- ========== 第二份：复制一份，无缝循环关键 ========== -->
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame.png" alt="模式闭环" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">模式闭环</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">全产业链贯通，品质成本双可控</p>
            </div>
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame_1.png" alt="技术领先" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">技术领先</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">JF-A 仿生仓 + 8 项专利，效率提升 30%+</p>
            </div>
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame_2.png" alt="渠道确定" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">渠道确定</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">包销协议锁定，以销定产现金流稳</p>
            </div>
            <div class="md:w-[20%] w-[15%] flex-shrink-0 text-center">
              <img src="@/assets/home/Frame_3.png" alt="品种稀缺" class="md:w-[65px] w-[30px] h-auto mx-auto mb-4" />
              <h3 class="md:text-[24px] text-[12px] font-bold mb-4 text-black">品种稀缺</h3>
              <p class="text-gray-500 md:text-[12px] text-[8px] leading-relaxed">金耳/舞茸/双孢菇高溢价矩阵</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: "HomePage",
  data() {
    return {
      // 轮播图数组
      images: [
        {
          url: require("@/assets/home/Property_1_Rectangle_58.png"),
          title: "天津宝坻基地",
          link: "/about/base/detail?id=1"
        },
        {
          url: require("@/assets/home/Property_1_Rectangle_58_1.png"),
          title: "重庆江津基地",
          link: "/about/base/detail?id=2"
        },
        {
          url: require("@/assets/home/Property_1_Rectangle_58.png"),
          title: "天津宝坻基地",
          link: "/about/base/detail?id=1"
        },
        {
          url: require("@/assets/home/Property_1_Rectangle_58_1.png"),
          title: "重庆江津基地",
          link: "/about/base/detail?id=2"
        },
      ],
      isPause: false,
      // 当前显示第几张
      currentIndex: 0
    };
  },
  mounted() {
    this.run()
    this.loop()
  },
  computed: {
    // 当前显示的图片
    currentImage() {
      return this.images[this.currentIndex];
    }
  },
  destroyed() {
    if (this.rafId) cancelAnimationFrame(this.rafId)
  },
  methods: {
    run() {
      this.$refs.scroll.style.animationPlayState = "running"
    },
    stop() {
      this.$refs.scroll.style.animationPlayState = "paused"
    },
    prev() {
      this.currentIndex--
    },
    next() {
      this.currentIndex++
    },
    goDetail(id) {
      this.$router.push(`/product2/detail?id=${id}`);
    },

    loop() {
      this.isPause = false
      // 避免重复启动多个动画循环
      if (this.rafId) return
      const box = this.$refs.scroll
      if (!box) return
      const speed = 0.8 // 每帧位移，越大越快，可调
      // 一份内容宽度 = 总宽的一半（两份相同）
      const half = () => box.scrollWidth / 2

      const step = () => {
        if (!this.isPause) {
          box.scrollLeft += speed
          // 滚到一份结尾 → 减掉一份宽度，视觉无缝回到开头
          if (box.scrollLeft >= half()) {
            box.scrollLeft -= half()
          }
        }
        this.rafId = requestAnimationFrame(step)
      }
      this.rafId = requestAnimationFrame(step)
    },
    stopLoop() {
      this.isPause = true
    }
  }
};
</script>

<style scoped>
.home-page {
  font-family: "PingFang SC", sans-serif;
}

.feature-card {
  @apply flex flex-col items-center;
}

.scroll-box {
  animation: scroll 15s linear infinite;
  /* width: max-content; */
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}
</style>